'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _Avatar = require('../../components/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _modifiers = require('../../utils/modifiers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Avatar(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var columnModifiers = [].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _styledComponentsReactiveGrid.Column)));
  var avatarModifiers = [(0, _lodash.includes)(modifiers, 'primary') ? null : 'secondary', 'small'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, Avatar)));

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    {
      modifiers: columnModifiers,
      style: {
        // NOTE: inline styles to tweak grid components is necessary until there
        // modifier configs can be extended or the required styles are able to be
        // added with grid modifiers.
        display: 'flex'
      }
    },
    _react2.default.createElement(_Avatar2.default, _extends({ modifiers: avatarModifiers }, rest))
  );
}

Avatar.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Avatar.defaultProps = {
  modifiers: []
};

exports.default = Avatar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/InputField/Avatar.js
// module id = 1658
// module chunks = 2